// Install Material UI first:
// npm install @mui/material @emotion/react @emotion/styled
import React from "react";
import { Box, Typography } from "@mui/material";

function InfoBox( {headLine, infoText, onShowImages} ) {

  return (
    <Box
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.5)", // "primary.main" wäre theme color, "transparent"
        color: "white",
        padding: 2, // theme spacing (8px * 2 = 16px)
        borderRadius: 2,
        boxShadow: 3,
        textAlign: "left",
        width: 350,
        height: 250,
        marginTop: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end", // Link nach unten
        mt: 5,
        p: 2
      }}
    >
      <Typography variant="h6"> {headLine}</Typography>
      <Typography variant="h7" sx={{ whiteSpace: "pre-line" }}> {infoText}</Typography>
      <div>
        <p></p>
      <a
        href="https://www.google.com/maps?q=Thomas-Müntzer-Siedlung 5, 99638 Kindelbrück"
        style={{ color: "#0099ff", marginTop: "auto"}}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
      So findest du uns
      </a>
      </div>
    </Box>
  );
}

// <button onClick={onShowImages}>Bilder</button>   zwischen </a> und </div>
   
export default InfoBox;
